import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/core/auth/AuthContext';
import { LanguageProvider } from '@/core/i18n/LanguageContext';
import { ConfirmProvider } from '@/app/providers/ConfirmProvider';
import { GaugeSimulationProvider } from '@/app/providers/GaugeSimulationProvider';

/**
 * Provider order must match the historical App.js tree:
 * Auth → Language → Confirm → BrowserRouter → GaugeSimulation → (Toaster + routes).
 */
export function AppProviders({ children }) {
  return (
    <AuthProvider>
      <LanguageProvider>
        <ConfirmProvider>
          <BrowserRouter>
            <GaugeSimulationProvider>
              <Toaster
                position="top-center"
                richColors
                closeButton
                theme="dark"
              />
              {children}
            </GaugeSimulationProvider>
          </BrowserRouter>
        </ConfirmProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}
